<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { DiscreteScaleLevel } from '@Scales/Model';

    @Component({
        props: {
            Comment: String,
            Value: Number,
            HasAnswer: Boolean,
            HasScale: Boolean,
            ScaleLevels: Array,            
        },
    })
    export default class SurveyVoteEditor extends Vue
    {
        setComment(comment: string | null)
        {
            this.$emit('update-comment', comment);
        }

        setDirectValue(val: any)
        {
            const value = parseFloat(val);
            this.$emit('update-value', value);
        }

        setScaleValue(sl: DiscreteScaleLevel)
        {
            const value = this.isSelected(sl) ? null : sl.Value;
            this.$emit('update-value', value);
        }

        isSelected(sl: DiscreteScaleLevel): boolean
        {
            return this.$props.Value === sl.Value;
        }
    }
</script>

<template>
    <div>
        <div v-if="HasScale">
            <div class="list-group">
                <button v-for="sl in ScaleLevels" @click="setScaleValue(sl)"
                        class="list-group-item list-group-item-action text-left" :class="{'active': isSelected(sl)}">

                    <i class="fa" :class="[isSelected(sl) ? 'fa-check-circle' : 'fa-circle-thin' ]"></i> {{sl.Name}} ({{sl.Value}})

                <p v-if="sl.Definition" class="mb-0">{{sl.Definition}}</p>
                </button>
            </div>
            <textarea rows="3" :value.trim="Comment" @input="setComment($event.target.value)" class="form-control my-3" placeholder="Comment..."></textarea>

            <button v-if="!HasAnswer" type="button" class="btn btn-secondary" @click="setComment('Skipped')">
                Skip (don't guess)
            </button>
        </div>

        <div v-if="!HasScale">
            <input type="number" :value="Value" @input="setDirectValue($event.target.value)" class="form-control" />
            <textarea rows="3" :value.trim="Comment" @input="setComment($event.target.value)" class="form-control my-3" placeholder="Comment..."></textarea>
            
            <button  v-if="!HasAnswer" type="button" class="btn btn-secondary" @click="setComment('Skipped')">
                Skip (don't guess)
            </button>
        </div>
    </div>
</template>